// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"labels_wrapper_1aadz","right":"labels_right_2CI6J","left":"labels_left_2G3ez","center":"labels_center_1Q56N"};